import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentChurnGauge from './StudentChurnGauge';
import { StudentChurnListService } from '../../services/CustomerSuccessKpiListService';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';

class StudentChurnCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentChurnListService.load();
  }

  render() {
    const data = toJS(StudentChurnListService.getByCompanyId(this.props.companyId));
    return (
      <StudentChurnGauge
        loading={StudentChurnListService.fetchCurrent.fetching || StudentChurnListService.fetchPrevious.fetching}
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_CHURN', this.props.companyId)}
        formatter={StudentChurnListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentChurnCompanyGaugeContainer);
